import * as Chat from './chat'
import * as User from './user'
import * as Worklist from './worklist'
import * as Messages from './messages'
import * as Statistics from './statistics'
import * as Msgk from './msgk'
import * as Log from './log'
import * as GeneralSettings from './generalSettings'
import * as Supplier from './supplier'

export default {
  login: User.login,
  register: User.register,
  getUserByEmail: User.getUserByEmail,
  getUsers: User.getUsers,
  updateUser: User.updateUser,
  newUser: User.newUser,
  deleteUser: User.deleteUser,
  getConversations: Chat.getConversations,
  getConversationById: Chat.getConversationById,
  getWorklist: Worklist.getWorklist,
  getWorklistByQuery: Worklist.getWorklistByQuery,
  getWorklistById: Worklist.getWorklistById,
  deleteWorklist: Worklist.deleteWorklist,
  getMessagesById: Messages.getMessagesById,
  exportJSON: Worklist.exportJSON,
  exportCSV: Worklist.exportCSV,
  getStatisticsByQuery: Statistics.getStatisticsByQuery,
  getStatuses: Worklist.getStatuses,
  getPayments: Worklist.getPayments,
  getMsgks: Msgk.getMsgks,
  getMsgksByTeam: Msgk.getMsgksByTeam,
  getMsgkByMaterialGrp: Msgk.getMsgkByMaterialGrp,
  updateMsgk: Msgk.updateMsgk,
  addNewMsgk: Msgk.addNewMsgk,
  getNegoLogics: Worklist.getNegoLogics,
  getTeams: Worklist.getTeams,
  getLogs: Log.getLogs,
  exportMsgk: Msgk.exportMsgk,
  exportLogs: Log.exportLogs,
  saveSettings: GeneralSettings.saveSettings,
  getSettings: GeneralSettings.getSettings,
  getSuppliers: Supplier.getSuppliers,
  getSupplierById: Supplier.getSupplierById,
  updateSupplier: Supplier.updateSupplier,
  addNewSupplier: Supplier.addNewSupplier,
  exportSupplier: Supplier.exportSupplier,
  getSuppliersByTeam: Supplier.getSuppliersByTeam,
  getFeedbacks: Worklist.getFeedbacks,
  getSecurityQ: User.getSecurityQ,
  changePassword: User.changePassword

}